import { get, local } from "@/request/http";

// 获取申报项目信息
export const getVirtualSimulationInfo = id =>
  get("/getVirtualSimulationInfo/" + id);

// 获取实验信息
export const getExpInfoWebApp = id => get("/getExpInfoWebApp/" + id);

// 获取访问数据列表
export const getExpInfoByExpidEcWebApp = id =>
  get("/getExpInfoByExpidEcWebApp/" + id);

// 获取访问数据
export const getExpCountWebapp = id => get("/getExpCountWebapp/" + id);

// 获取反馈分页
export const getSpitPageCountWebApp = (id, count) =>
  get("/getSpitPageCountWebApp/" + id + "/" + count);

// 获取反馈信息
export const getSpitListWebApp = (id, page, count) =>
  get("/getSpitListWebApp/" + id + "/" + page + "/" + count);

// 获取视频列表
export const getVideos = () =>
  local({
    video: [
      "https://moolsnetvideo.oss-cn-beijing.aliyuncs.com/%E5%8F%AF%E7%87%83%E5%86%B0%E7%AE%80%E4%BB%8B%E8%A7%86%E9%A2%91_10.mp4",
      "https://moolsnetvideo.oss-cn-beijing.aliyuncs.com/%E5%8F%AF%E7%87%83%E5%86%B0%E5%BC%95%E5%AF%BC%E8%A7%86%E9%A2%91-10.mp4"
    ],
    videoImg: [
      "https://moolswebapp.oss-cn-beijing.aliyuncs.com/150/%E8%A7%86%E9%A2%91%E5%B0%81%E9%9D%A2.jpg",
      "https://moolswebapp.oss-cn-beijing.aliyuncs.com/150/%E8%A7%86%E9%A2%91%E5%B0%81%E9%9D%A2.jpg"
    ]
  });

// 获取教师信息列表
export const getInfoList = () =>
  local([
    // {
    //   image:
    //     "http://121.40.73.41/upload/upfile//website_experiment/0129d37165ea4efdaa55b24ed6ffdaa7.png",
    //   name: "夏晋",
    //   title: "博士 /教授 /硕士研究生导师",
    //   desc: "清华大学美术学院访问学者等"
    // },
    // {
    //   image:
    //     "http://121.40.73.41/upload/upfile//website_experiment/e5790a3bee4c405aa751b1ee25b3e953.png",
    //   name: "罗彬",
    //   title: "教授 /国家一级美术师 /硕士研究生导师",
    //   desc: "湖北省“五一”劳动奖章获得者等"
    // },
    // {
    //   image:
    //     "http://121.40.73.41/upload/upfile//website_experiment/2dcf533c107c420ca14fb530a52c6e76.png",
    //   name: "吴海广",
    //   title: "教授/院长 /硕士研究生导师",
    //   desc: "主持项目： 民族美术实验教学体系构建与改革研究等"
    // },
    // {
    //   image:
    //     "http://121.40.73.41/upload/upfile//website_experiment/230a2b88823c4551ac5ab05f5c13a022.png",
    //   name: "彭阳陵",
    //   title: "副教授 /副院长 /高级工艺美术师",
    //   desc: "湖北省风景园林协会湖北分会会员等"
    // },
    // {
    //   image:
    //     "http://121.40.73.41/upload/upfile//website_experiment/8effcaa4882544a99980b6ad73d4ff78.png",
    //   name: "赵衡宇",
    //   title: "博士 /副教授 /硕士研究生导师",
    //   desc: "上海同济大学访问学者等"
    // },
    // {
    //   image:
    //     "http://121.40.73.41/upload/upfile//website_experiment/a91d84e1199e4e7ba946dd601762de1c.png",
    //   name: "陈建强",
    //   title: "博士 /教授",
    //   desc: "东湖高新技术开发区 3551海外高层次人才"
    // },
    // {
    //   image:
    //     "http://121.40.73.41/upload/upfile//website_experiment/5e987ecd7f4b420ba617958454f04dfe.png",
    //   name: "万桃元",
    //   title: "吊脚楼木作建造师",
    //   desc: "国家级非遗代表性传承人"
    // },
    // {
    //   image:
    //     "http://121.40.73.41/upload/upfile//website_experiment/6144c9af4b4342bc94ac6a5ae0e6b164.png",
    //   name: "谢明贤",
    //   title: "吊脚楼木作建造师",
    //   desc: "省级非遗代表性传承人"
    // },
    // {
    //   image:
    //     "http://121.40.73.41/upload/upfile//website_experiment/eeef868e3b404a9199f0936981b64880.png",
    //   name: "何平",
    //   title: "省级非遗代表性传承人",
    //   desc: "高级技师（国家一级职业资格）"
    // },
    // {
    //   image:
    //     "http://121.40.73.41/upload/upfile//website_experiment/8182842c63364ec99fce0e3878e37124.png",
    //   name: "熊国江",
    //   title: "吊脚楼木作建造师",
    //   desc: "恩施州非遗代表性传承人"
    // },
    // {
    //   image:
    //     "http://121.40.73.41/upload/upfile//website_experiment/f8a64b0e3d794cba83460f3b3ec5a030.png",
    //   name: "王彪",
    //   title: "副教授 /硕士研究生导师",
    //   desc: "CIID中国建筑学会室内设计分会会员"
    // },
    // {
    //   image:
    //     "http://121.40.73.41/upload/upfile//website_experiment/95014561700a4741ace1424ea2174eec.png",
    //   name: "刘星",
    //   title: "博士",
    //   desc: "《材料构造与营造》课程主讲教师"
    // },
    // {
    //   image:
    //     "http://121.40.73.41/upload/upfile//website_experiment/7a5628c21e90472eb738880b4db71fe9.png",
    //   name: "陈星",
    //   title: "博士/ 讲师",
    //   desc: "《材料构造与营造》课程主讲教师"
    // }
  ]);

// 获取描述
export const getDesc = id =>
  get("/getVirtualSimulationInfoV2", {
    id: id,
    param: "desc"
  });
